// extracted by mini-css-extract-plugin
export default {"item":"ListItem_item__BSk-2","img1":"ListItem_img1__VAe9N","img2":"ListItem_img2__3VUyW"};